import { render, staticRenderFns } from "./DataGridV2.vue?vue&type=template&id=64197f7d&scoped=true"
import script from "./DataGridV2.vue?vue&type=script&lang=js"
export * from "./DataGridV2.vue?vue&type=script&lang=js"
import style0 from "./DataGridV2.vue?vue&type=style&index=0&id=64197f7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64197f7d",
  null
  
)

export default component.exports